{
  "date": "Date",
  "time": "Time",
  "invoiceNumber": "Invoice number",
  "kind": {
    "CASH_SALE": "Cash sale",
    "DEBT_SALE": "Debt sale",
    "PURCHASE": "Purchase",
    "PAYMENT": "Payment",
    "RECEIPT": "Receipt",
    "DEBT_REPAYMENT": "Debt repayment"
  },
  "table": {
    "category": "Category",
    "qty": "Qty",
    "price": "Amount"
  },
  "lessJerrycans": "Less jerrycans",
  "total": "Total",
  "vehiclePlate": "Vehicle plate",
  "debtorName": "Customer name",
  "personName": "Person name",
  "statement": "Statement",
  "thankYou": "Thank you for visiting",
  "print": "Print",
  "close": "Close",
  "resultTitle": "Operation completed successfully",
  "openingBalanceSaved": "Carried balance saved",
  "pendingNotice": "The transaction was saved as pending until it is posted"
}
